import React from 'react';
import { colors, Grid, makeStyles, Typography } from '@material-ui/core';

import Routes from 'config/routes';
import APP_NAME from 'config/app_name';

import Link from 'components/Link';
import Description from 'components/typography/Description';

const useStyles = makeStyles({
  link: {
    fontFamily: 'Fredoka One, cursive',
    color: colors.red[400],
    '&:hover': {
      color: colors.red[200],
    },
  },
  appName: {
    color: colors.red[400],
    fontFamily: 'Pacifico,cursive',
  },
});

const GoToCreateAccountPage = () => {
  const classes = useStyles();

  return (
    <Grid container direction="column">
      <Grid item container justify="center">
        <Description>
          New to <span className={classes.appName}>{APP_NAME}</span> ?
        </Description>
      </Grid>

      <Grid item container justify="center" style={{ marginTop: 8 }}>
        <Link pathname={Routes.createAccount()}>
          <Typography variant="body1">
            <span className={classes.link}>Create account</span>
          </Typography>
        </Link>
      </Grid>
    </Grid>
  );
};

export default GoToCreateAccountPage;
